import { Blog, Tags } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import AppLink from '@/components/common/AppLink';
import BadgeCard from '@/components/general/BadgeCard';

export default function BlogTags({ tags, tagSlug }: { tags?: Tags[]; tagSlug?: string | null }) {
  return (
    <div className={`${styles.tag_cloud}`}>
      {tags?.map((item: Tags, index: number) => (
        <AppLink key={index} href={`/blogs?tag=${item?.slug}`}>
          <BadgeCard
            item={{ ...item }}
            mainStyle="hover"
            className={`${styles.singleTag} ${item?.slug == tagSlug && styles.activeTag}`}
            showdot={false}
          />
        </AppLink>
      ))}
    </div>
  );
}
